import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  private validUrls = [
    '/site/documents',
    '/global/documents',
    '/preview/documents',
  ];
  constructor(
    //private router: Router,
    private authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const previewSiteToken = route.queryParamMap.get('previewSiteToken');
    if (previewSiteToken) {
      this.authService.setUserFromToken(previewSiteToken);
      console.log(
        'PreviewSiteToken found :' +
          previewSiteToken +
          ' : ' +
          state.url +
          '. Guard returning true'
      );
      return true;
    } else if (this.authService.isAuthenticated()) {
      // logged in so return true
      const currentUser = this.authService.getCurrentUser();
      this.authService.addUserDetailsToExternalServices(currentUser);
      console.log(
        'User is authenticated : ' +
          currentUser?.preferred_username +
          ' : current url - ' +
          state.url
      );
      return true;
      // this.authService.loginSso('');
      // let activated: Observable<boolean> = new Observable<boolean>(
      //   (subscriber) => {
      //     subscriber.next(true);
      //   }
      // );
      // return activated;
    } else {
      const partialAuthKey = route.queryParamMap.get('key');
      if (
        this.isValidUrl(state.url) &&
        partialAuthKey &&
        !this.authService.isUserLoggedInPreviously()
      ) {
        //this.authService.setUserFromToken(partialAuthKey);
        this.authService.redirectToPartialAuthUrl(partialAuthKey);
        console.log(
          'User non authenticated : partial auth key found :' +
            partialAuthKey +
            ' : ' +
            state.url +
            '. Guard returning false'
        );
        return false;
      } else {
        console.log(
          'User non authenticated : redirecting to login page. Original Url before redirection - ' +
            state.url
        );
        this.authService.loginSso(state.url);
        return false;
        //return this.authService.authenticationEventObservable;
      }
    }
  }

  isValidUrl(requestUrl: string) {
    for (const subUrl of this.validUrls) {
      if (requestUrl.startsWith(subUrl)) {
        return true;
      }
    }
    return false;
  }
}
